import TBIcon from '../compoment/Icon';
import './login.scss';
import { Input, Button, message, Tabs, Checkbox, Tooltip, Modal } from 'antd';
import { login, getUserLoginInfo, sendTextCode, checkLoginUserIsExist } from '../utils/servers';
import { useState, useRef } from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import actions from '../utils/actions';
import { GetUrlParam } from '../utils';
import ReactSimpleVerify from 'react-simple-verify';
import { debounce } from 'lodash';
import { WechatOutlined } from '@ant-design/icons';
import 'react-simple-verify/dist/react-simple-verify.css';
import UserAgreement from '../compoment/userAgreement';
import { orgUsertree } from '../utils/dataProcessing';
function Login(props) {
	const { saveLoginInfo, saveMenus, saveSySMenus, addUserOrgs, addUserInfo, addHeaderParentIds } = props;
	const [phone, setPhone] = useState('');
	const [code, setCode] = useState('');
	const [msgId, setMsgId] = useState('');
	const history = useHistory();
	const [codeTip, setCodeTip] = useState('获取');
	const [successTips, setSuccessTips] = useState('验证中..');
	const [successIcon] = useState('');
	const [disabledCode, setDisabledCode] = useState(true);
	const [showCodeBtn, setShowCodeBtn] = useState(false);
	const [matchedPhone, setMatchedPhone] = useState('');
	const couterRef = useRef();
	const orgTypeCode = GetUrlParam('code');
	const [updateKey, setUpdateKey] = useState(1);
	// const bgImg = {
	// 	1002015: 'fws',
	// 	1002010: 'yg',
	// 	1002020: 'syd'
	// };
	// const TypeName = {
	// 	1002015: '人力资源服务商',
	// 	1002010: '用工企业',
	// 	1002020: '运营商'
	// };
	// 判断生产环境
	const isProdEnv = process.env.REACT_APP_ENVVAR === 'production';

	const wxQrcodeUrl = isProdEnv
		? `https://open.weixin.qq.com/connect/qrconnect?appid=wx09a0f36736c3c98c&redirect_uri=https%3A%2F%2Fwww.fclgyun.com%2FwxLogin%3Fenv%3D${
				getUrlValue('env') === undefined ? 'prod' : getUrlValue('env')
		  }&response_type=code&scope=snsapi_login&state=tbnb#wechat_redirect`
		: '';

	// 回车键登入
	document.onkeydown = keyListener;
	function keyListener(e) {
		// 当按下回车键，执行我们的代码
		if (code && e.keyCode === 13) {
			gotoLogin();
		}
	}

	useEffect(() => {
		const searchParams = new URLSearchParams(window.location.search);
		console.log(searchParams.get('token'));
	}, []);

	const gotoLogin = () => {
		if (code && codeCheckbox) {
			if (phone !== matchedPhone) {
				message.error('手机号与验证码不匹配，请稍后重试');
			} else {
				if (getUrlValue('env')) {
					localStorage.setItem('env', getUrlValue('env'));
				} else {
					localStorage.setItem('env', '');
				}
				login({ phone, code, msgId, orgTypeCode }).then((data) => {
					if (data.code === '200') {
						saveLoginInfo(data.data);
						Cookies.set('token', data.data.accessToken);
						localStorage.setItem('loginInfo', JSON.stringify(data.data));
						console.log(data.data, 'data.data');
						actions.setGlobalState({ loginInfo: data.data }); //通知主应用并修改initstate
						getUserLoginInfo().then((res) => {
							if (res.code === '200') {
								localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo) || {});
								actions.setGlobalState({ userInfo: res.data.userInfo });
								localStorage.setItem('menus', JSON.stringify(res.data.userRoleFuncList));
								saveMenus(res.data.userRoleFuncList ? res.data.userRoleFuncList : []);
								saveSySMenus(res.data.userRoleFuncList ? res.data.userRoleFuncList : []);
								addUserOrgs(orgUsertree(res.data.userOrgsInfoList) || []);
								addUserInfo(res.data.userInfo || {});
								addHeaderParentIds(res.data.userRoleFuncList[0]?.id);
								localStorage.setItem('myWorkplat', JSON.stringify(res.data.userWorkbenchList) || []);
								// addMenusHistory(
								// 	res.data.userWorkbenchList.includes('1276005')
								// 		? [
								// 				{
								// 					path: '/zeus-system/system-permissions/workingPlatform',
								// 					name: '我的工作台',
								// 					parentId: '523523270839386118'
								// 				}
								// 		  ]
								// 		: []
								// );
								// window.location.reload();
							}
							history.push('/');
						});
					} else {
						message.error(data.msg || '账号异常，请稍后重试');
					}
				});
			}
		}
	};
	const changePhone = (event) => {
		setPhone(event.target.value);
	};
	const changeCode = (event) => {
		setCode(event.target.value);
	};
	const getCode = () => {
		if (!disabledCode) return;
		setDisabledCode(false);
		let i = 60;
		setCodeTip(`${i}S`);
		const T = setInterval(() => {
			i--;
			setCodeTip(`${i}S`);
			if (i <= 0) {
				clearInterval(T);
				setDisabledCode(true);
				setCodeTip(`获取`);
			}
		}, 1000);
		sendTextCode({ phone: phone }).then((data) => {
			if (data.code === '200') {
				setDisabledCode(false);
				setMsgId(data.data.msgId);
				setMatchedPhone(phone);
			} else {
				message.error(data.msg);
			}
		});
	};
	const checkPhone = () => {
		return checkLoginUserIsExist({
			phone,
			orgTypeCode
		});
	};
	const success = debounce(() => {
		if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone)) {
			checkPhone().then((data) => {
				if (data.success) {
					setShowCodeBtn(true);
					setSuccessTips('验证成功');
				} else {
					couterRef.current.reset();
				}
			});
		} else {
			message.warn('请正确输入手机号');
			couterRef.current.reset();
		}
	}, 500);
	// const register = () => {
	// 	window.location.href = `${process.env.REACT_APP_REGISTEREDAUDIT_URL}/registered-audit-manager/businessDetail`;
	// };
	const [maskVisible, setMaskVisible] = useState(true);
	const [codeCheckbox, setCodeCheckbox] = useState(true);

	//截取url中的参数
	function getUrlValue(kValue) {
		var url = window.location.href; //当前页面的地址
		var reg = /([^?&=]+)=([^?&=]+)/g;
		var obj = {};
		url.replace(reg, function () {
			obj[arguments[1]] = arguments[2];
		});
		for (var keyName in obj) {
			if (keyName === kValue) {
				return obj[keyName];
			}
		}
	}
	const onChange = (key) => {
		console.log(key);
	};
	const changeCheckbox = () => {
		setMaskVisible(!maskVisible);
	};
	const changeCodeCheckbox = () => {
		setCodeCheckbox(!codeCheckbox);
	};

	let [isModalOpen, setIsModalOpen] = useState(false);
	const openAgreement = () => {
		setIsModalOpen(true);
	};
	const handleModalOk = () => {
		setIsModalOpen(false);
		setUpdateKey(new Date().getTime());
	};
	const handleModalCancel = () => {
		setIsModalOpen(false);
		setUpdateKey(new Date().getTime());
	};

	return (
		<div className="Login">
			<div className={'login-wrap syd'}>
				<div className="login-left">
					<div className="login">
						<TBIcon type="tb-logo-y" />
						<p>蜂巢灵工</p>
					</div>
					<div className="login-title">
						<h1>企业用工数字化平台</h1>
						<p>服务、创新、科技、未来</p>
					</div>
				</div>
				<div className="login-right">
					<div className="login-right-tabs">
						<Tabs defaultActiveKey="1" onChange={onChange}>
							{isProdEnv && (
								<Tabs.TabPane tab="扫码登录" key="1">
									<div className="iframeBox">
										<iframe
											className="qrIframe"
											title={' '}
											frameBorder="0"
											sandbox="allow-scripts allow-same-origin allow-top-navigation"
											scrolling="no"
											src={wxQrcodeUrl}></iframe>
										{!maskVisible ? (
											<div className="mask">
												<span></span>
												<p>请阅读并勾选下方协议，开启扫码</p>
											</div>
										) : (
											<div></div>
										)}
									</div>
									<div className="fileTip dmt40">
										<Tooltip
											placement="bottomLeft"
											title={!maskVisible ? '请先阅读并同意协议' : ''}
											arrowPointAtCenter
											visible={!maskVisible}>
											<Checkbox onChange={changeCheckbox} defaultChecked={true}></Checkbox>
										</Tooltip>
										<span>阅读并同意</span>
										<span onClick={openAgreement}>《用户服务协议》</span>
									</div>
									<div className="wxIcon">
										<WechatOutlined style={{ fontSize: '24px', color: '#fff' }} />
									</div>
								</Tabs.TabPane>
							)}
							<Tabs.TabPane tab="验证码登录" key="2">
								<div>
									<div className="login-right-tel">
										<p>+86 |</p>
										<Input placeholder="请输入手机号" value={phone} onChange={changePhone} />
									</div>

									<ReactSimpleVerify
										disabled
										ref={couterRef}
										successTips={successTips}
										width={300}
										height={40}
										successIcon={successIcon}
										movedColor={'#FC6732'}
										success={success}
									/>
									{showCodeBtn && (
										<div className="login-right-Code">
											<Input placeholder="请输入验证码" value={code} onChange={changeCode} />
											<Button type="primary" onClick={getCode}>
												{codeTip}
											</Button>
										</div>
									)}
									<div className="fileTip mt24">
										<Tooltip
											placement="bottomLeft"
											title={!codeCheckbox ? '请先阅读并同意协议' : ''}
											arrowPointAtCenter
											visible={!codeCheckbox}>
											<Checkbox onChange={changeCodeCheckbox} defaultChecked={true}></Checkbox>
										</Tooltip>
										<span>阅读并同意</span>
										<span onClick={openAgreement}>《用户服务协议》</span>
									</div>
									<div style={{ marginTop: '24px' }}>
										<Button
											className={code && codeCheckbox ? 'loginButton' : 'loginButtonDisabled'}
											type="primary"
											onClick={gotoLogin}>
											登录
										</Button>
									</div>

									<div className="register">
										{/* <span>没有账号？</span>
										<span className="registerButton" onClick={register}>
											立即注册
										</span> */}
									</div>
								</div>
							</Tabs.TabPane>
						</Tabs>
						<Modal
							maskClosable={false}
							closable
							key={updateKey}
							title="用户服务协议"
							visible={isModalOpen}
							width="50%"
							footer={
								<Button type="primary" onClick={handleModalOk}>
									同意
								</Button>
							}
							onOk={handleModalOk}
							onCancel={handleModalCancel}>
							<UserAgreement></UserAgreement>
						</Modal>
					</div>
					<span className="copyRight">版权所有 © 2021 福建桐邦信息科技有限公司 | 闽ICP备2021001372号-2</span>
				</div>
			</div>
		</div>
	);
}
const mapStateToProps = (state) => {
	return {
		menusHistory: state.menusHistory
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		saveLoginInfo: (info) => dispatch({ type: 'ADD_LOGININFO', info }),
		saveMenus: (info) => dispatch({ type: 'ADD_MENUS', info }),
		addUserOrgs: (info) => dispatch({ type: 'ADD_USERORGS', info }),
		addUserInfo: (info) => dispatch({ type: 'ADD_USERINFO', info }),
		addMenusHistory: (info) => dispatch({ type: 'ADD_MENUSHISTORY', info }),
		saveSySMenus: (info) => dispatch({ type: 'ADD_SYSMENUS', info }),
		addHeaderParentIds: (info) => dispatch({ type: 'ADD_HEADERPARENTID', info })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
